import { useRef } from "react";
import html2pdf from "html2pdf.js";

const tableStyles = {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "2px",
  fontFamily: "Arial, sans-serif",
  marginBottom: "2%",
};
const trStyles = {
  height: "4vh",
};

const thTdStyles = {
  border: "1px solid #999",
  padding: "8px",
  textAlign: "left",
};

const thStyles = {
  ...thTdStyles,
  backgroundColor: "#f2f2f2",
  fontWeight: "bold",
};

const QuotationTable = ({ data }) => {
  console.log(data);
  const items = data?.resultWithStats;
  const tableRef = useRef();

  const handleDownload = () => {
    const element = tableRef.current;
    const opt = {
      margin: 0.5,
      filename: "quotation-summary.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    html2pdf().set(opt).from(element).save();
  };
  const cellHeader = {
    padding: "10px 12px",
    border: "1px solid #ccc",
    fontWeight: "bold",
  };

  const cellBody = {
    padding: "10px 12px",
    border: "1px solid #eee",
  };

  return (
    <div>
      <button
        onClick={handleDownload}
        style={{
          padding: "8px 16px",
          marginBottom: "10px",
          backgroundColor: "#4caf50",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Download PDF
      </button>
      <div style={{ overflow: "auto", height: "60vh" }}>
        <div
          ref={tableRef}
          style={{
            fontFamily: "Arial, sans-serif",
            fontSize: "14px",
            color: "#333",
          }}
        >
          {/* Gross Summary Card */}
          <div
            style={{
              backgroundColor: "#f5f5f5",
              border: "1px solid #ddd",
              borderRadius: "8px",
              padding: "20px",
              marginBottom: "24px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            <h4 style={{ fontSize: "18px", marginBottom: "15px" }}>
              <strong>Gross Summary</strong>
            </h4>
            <div style={{ display: "flex", gap: "3%", flexWrap: "wrap" }}>
              <div>
                <strong>Gross High Price:</strong> ₹
                {data.grossSummary?.grossHighPrice}
              </div>
              <div>
                <strong>Gross Low Price:</strong> ₹
                {data.grossSummary?.grossLowPrice}
              </div>
              <div>
                <strong>Gross Avg Price:</strong> ₹
                {data.grossSummary.grossAvgPrice}
              </div>
            </div>
          </div>

          {/* Item wise quotations */}
          {items.map((item, idx) => (
            <div
              key={idx}
              style={{
                backgroundColor: "#fff",
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "20px",
                marginBottom: "24px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              }}
            >
              <h5
                style={{
                  fontSize: "16px",
                  marginBottom: "12px",
                  color: "#4a4a4a",
                }}
              >
                <strong>{item.item}</strong>
              </h5>
              <div
                style={{
                  display: "flex",
                  gap: "3%",
                  marginBottom: "12px",
                  flexWrap: "wrap",
                }}
              >
                <div>
                  <strong>Highest Price:</strong> ₹
                  {item.totalItemPrices.highestPrice}
                </div>
                <div>
                  <strong>Lowest Price:</strong> ₹
                  {item.totalItemPrices.lowestPrice}
                </div>
                <div>
                  <strong>Average Price:</strong> ₹
                  {item.totalItemPrices.averagePrice}
                </div>
              </div>

              {/* Table */}
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "13px",
                  border: "1px solid #ccc",
                }}
              >
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#f0f0f0",
                      height: "40px",
                      textAlign: "left",
                    }}
                  >
                    <th style={cellHeader}>Sl No.</th>
                    <th style={cellHeader}>Vendor Name</th>
                    <th style={cellHeader}>Quantity</th>
                    <th style={cellHeader}>Single Item Price</th>
                    <th style={cellHeader}>Total Price</th>
                  </tr>
                </thead>
                <tbody>
                  {item.quotations.map((q, i) => (
                    <tr
                      key={i}
                      style={{
                        borderBottom: "1px solid #e0e0e0",
                        height: "36px",
                      }}
                    >
                      <td style={cellBody}>{i + 1}</td>
                      <td style={cellBody}>{q.from}</td>
                      <td style={cellBody}>{q.qty}</td>
                      <td style={cellBody}>₹{q.singleItemPrice}</td>
                      <td style={cellBody}>₹{q.totalPrice}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuotationTable;
